<script>
import Avatar from 'next/avatar/Avatar.vue';
import CheckBox from 'next/wgpt/Form/CheckBox.vue';
import FilterItem from './FilterItem.vue';
import ContactWrapper from 'next/wgpt/ContactWrapper.vue';

export default {
  components: {
    Avatar,
    CheckBox,
    FilterItem,
    ContactWrapper,
  },
  props: {
    modelValue: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      updatedValue: this.modelValue,
    };
  },
  watch: {
    updatedValue(value) {
      this.$emit('update:modelValue', value);
    },
    modelValue(value, oldValue) {
      if (value.join() === oldValue.join()) return;
      this.updatedValue = value;
    },
  },
};
</script>

<template>
  <div>
    <FilterItem
      v-for="selectedId in updatedValue"
      :key="selectedId"
      class="group py-1.5"
    >
      <template #start>
        <CheckBox v-model="updatedValue" :value="selectedId" />
      </template>
      <ContactWrapper :contact-id="selectedId">
        <template #default="{ contact }">
          <div class="flex flex-row justify-between">
            <Avatar :src="contact.thumbnail" :name="contact.name" :size="24" />
          </div>
          <span class="truncate">{{ contact.name }}</span>
        </template>
      </ContactWrapper>
    </FilterItem>
  </div>
</template>
